import { CSSProperties, useLayoutEffect, useState } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    width: 100%;

    .glass {
        /* From https://css.glass */
        background: rgba(255, 255, 255, 0);
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(5px);
    }
`;

const content = (height: number): CSSProperties => ({
    paddingTop: height,
});

interface Props {
    id: string;
    render?: any;
    children?: any;
    height: number;
}
export default function StickyHeader(props: Props) {
    const [float, setFloat] = useState(false);

    useLayoutEffect(() => {
        const header = document.getElementById(props.id);

        if (!header) return;

        const sticky = header.offsetTop;

        const check = () => {
            setFloat(window.scrollY > sticky);
        };

        window.addEventListener("scroll", check);

        return () => {
            window.removeEventListener("scroll", check);
        };
    }, [props.id]);

    return (
        <Wrapper>
            <div
                id={props.id}
                style={{
                    flex: 1,
                    height: props.height,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    ...(float && {
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        flex: 1,
                        zIndex: 100,
                        boxSizing: "border-box",
                    }),
                }}
                className={float ? "glass" : ""}>
                {props.render}
            </div>
            <div
                style={{
                    ...(float && content(props.height)),
                }}></div>
        </Wrapper>
    );
}
